import { DataBean } from "../DataBean";

export class Product extends DataBean {


    // public async getInventoryCatalog(prefix: any, loadRecipes: any, idStore: any): Promise<any> {
    //     return this.getCustomService("QuickDataERPCore", "java.util.List_getInventoryCatalog_String_Boolean_Number", [prefix, loadRecipes, idStore]);
    // }

    public async getInventoryCatalogReport(idLine: number, regexStr: string, type: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getInventoryCatalog_Number_String_Number_Number_Number", [idLine, regexStr, type, page, recordsPerPage]);
    }
    public async getInventoryCatalog(idLine: number, regexStr: string, type: number, productCode: any, reference: any, idProduct: any, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getInventoryCatalog_Number_String_Number_Number_Number_Number_Number_Number", [idLine, regexStr, type, productCode, reference, idProduct, page, recordsPerPage]);
    }

    public async getProductTypeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductTypeConstants_Number", [arg]);
    }

    //AddedValue
    public async getProductTaxsCatalogForAddedValue(idProduct: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductTaxsCatalogForAddedValue_Number", [idProduct]);
    }

    public async getTaxSchemaValuesForAddedValue(idTaxScheme: number, idProduct: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductTaxSchemaValuesForAddedValue_Number_Number", [idTaxScheme, idProduct]);
    }

    public async getTaxSchemeCatalogWithAddedValue(idTaxSchemeContext: number, adquisitionArticleType: number, taxFilerType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxSchemeCatalogWithAddedValue_Number_Number_Number", [idTaxSchemeContext, adquisitionArticleType, taxFilerType]);
    }

    //Holding Value
    public async getProductTaxsCatalogForHoldingValue(idProduct: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductTaxsCatalogForHoldingValue_Number", [idProduct]);
    }

    public async getProductTaxSchemaValuesForHoldingValue(idTaxScheme: number, idProduct: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductTaxSchemaValuesForHoldingValue_Number_Number", [idTaxScheme, idProduct]);
    }

    public async getTaxSchemeCatalogWithHoldingTax(idTaxSchemeContext: number, adquisitionArticleType: number, taxFilerType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxSchemeCatalogWithHoldingTax_Number_Number_Number", [idTaxSchemeContext, adquisitionArticleType, taxFilerType]);
    }

    public async addProductTax(idProduct: number, idTaxSchemeValue: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.ProductTax_addProductTax_Number_Number", [idProduct, idTaxSchemeValue]);
    }

    public async removeProductTax(idProduct: number, idTaxSchemeValue: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_removeProductTax_Number_Number", [idProduct, idTaxSchemeValue]);
    }

    public async importProductCatalog(filename: number, directory: number, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importProductCatalog_String_String_String", [filename, directory, dataStore]);
    }

    public async getProductVariantCatalog(idProduct: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductVariantCatalog_Number", [idProduct]);
    }

    public async getPriceListItemCatalogByProduct(idProduct: number, idStore: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPriceListItemCatalogByProduct_Number_Number", [idProduct, idStore]);
    }
}